import React from 'react'
import { InputError, Toggle } from '@foodsby/nutrient'
import { Panel } from '../common/Layout'

export const PanelPrivacyPreferences = ({
  privacy = {},
  updateUserPrivacyStart,
  updateUserPrivacyError,
}) => (
  <Panel>
    <h2 className="panel-title">Public Profile</h2>
    <div>
      <div className="row middle-xs">
        <div className="col-xs-12 col-lg-9">
          <label>
            Appear to others on Foodsby, like for friend suggestions and
            searches.
          </label>
        </div>
        <div className="col-xs-12 col-lg-3" style={{ paddingTop: '12px' }}>
          <Toggle
            checked={privacy.searchable}
            name="searchable"
            onChange={e =>
              updateUserPrivacyStart({ searchable: e.target.checked })
            }
          />
          <label htmlFor="searchable" />
        </div>
      </div>
    </div>
    {updateUserPrivacyError && (
      <InputError
        visible={updateUserPrivacyError && updateUserPrivacyError !== null}
      >
        {(updateUserPrivacyError.data && updateUserPrivacyError.data.error) ||
          'Oops! Something went wrong. If this continues to happen, please contact support.'}
      </InputError>
    )}
  </Panel>
)

export default PanelPrivacyPreferences
